<template>
    <div>
        <WeightValidation ref="WeightValidation"></WeightValidation>
        <b-row>
            <!-- ***************
            UNPACK
            *****************-->
            <b-col xl="2">
                <div class="col-header mb-3 pb-3 border-bottom">
                    <span class="h4"><i class="fa-solid fa-sign-out-alt"></i> Unpack</span>
                    <b-button size="sm" variant="primary" @click="refreshBatchOrderList"
                              class="float-right">
                        <i class="fab fa-gripfire"></i> Reload
                    </b-button>
                </div>
                <b-card no-body class="mb-0">
                    <div class="bg-secondary p-2">
                        <strong>Purity Bag Count</strong> <b-badge variant="primary" pill class="float-right"><h6 class="m-0 p-0">{{  batchPurityBagCount }}</h6></b-badge>
                    </div>
                </b-card>

                <b-card body-class="px-3 py-1" class="-lg">
                    <LoadingSpinner :busy="orderLoading"/>
                    <ul v-if="!orderLoading" class="list-unstyled">
                        <li class="unpack-batch-date" v-for="(val) in batch" :key="val.date">
                            <div @click="toggleUnpackBatchDates(val.date)">
                                <i class="fa-light fa-box-open mr-2"></i>
                                <b>{{ val.date }}</b> ({{ val.num_orders }})
                            </div>
                            <ul :id="val.date" class="list-unstyled ml-4 unpack-batch-orders is-closed">
                                <li class="unpack-batch-order"
                                    v-for="(val2) in val.orders"
                                    :key="val2.order_id"
                                    @click="getOrder(val2.id)">
                                    {{ val2.id }} {{ val2.customer.last_name }} ({{ val2.inventory_count }})
                                </li>
                            </ul>
                        </li>
                    </ul>
                </b-card>
            </b-col>


            <!-- ***************
            Items to BATCH
            *****************-->
            <b-col xl="5">
                <div class="col-header mb-3 pb-3 border-bottom">
                    <template v-if="order == null">
                        <span class="h4"><i class="fa-solid fa-exchange"></i> Batch</span>
                    </template>
                    <template v-else>
                        <span class="h4">
                            <a class="text-dark"
                               :href="`/kit/view/${order.id}`">Order {{ order.id }} {{ order.customer.last_name}}</a>
                        </span>
                        <b-button size="sm" variant="primary" @click="refreshBatch"
                                  class="float-right">
                            <i class="fa-regular fa-print"></i> Refresh Batch
                        </b-button>
                    </template>
                </div>
                <b-card v-if="!order" bg-variant="info">
                    <i class="fa-regular fa-barcode float-left mt-1 mr-1"></i>
                    Place a kit on the scale and scan its barcode to begin. Click
                    <a class="text-white font-weight-bold" href="https://stagingadmin.apigx.com/batchcommands.pdf" target="_blank">here</a>
                    for a printable list of command codes.
                </b-card>




                <template>
                    <transition name="slide-fade">
                        <b-card v-if="!order_verified && order" bg-variant="warning" class="text-dark">
                            <b-button class="float-right" @click="order_verified = !order_verified" size="sm">x</b-button>
                            <i class="fa-solid fa-weight mr-2"></i>Place order {{ order.id }} ({{ order.customer.last_name }})
                            on the scale and scan barcode to verify.
                        </b-card>
                    </transition>


                    <div :class="order ? '': 'd-none'">

                        <!-- HOLD -->
                        <b-card class="" body-class="py-3" header-class="p-2">
                            <template v-slot:header>
                                <span class="h6"><i class="fa-solid fa-tags text-success"></i> To Hold</span>
                                <div class="batch-info mb-1">
                                    <span class="px-1">Weight: {{ getOrderStatusesTotals.hold.weight }}</span>
                                    <span class="px-1">Bags: {{ getOrderStatusesTotals.hold.bags }}</span>
                                    <span class="px-1">Items: {{ getOrderStatusesTotals.hold.items }}</span>
                                </div>
                            </template>
                            <batchTable
                                    :search="searchBatch"
                                    @updateOrderItems="updateOrderItems"
                                    @updateItemsOnMove="updateItemsOnMove"
                                    :seekItemsCallback="seekItemByGroup"
                                    :loading="!!singleOrderLoading || !!orderLoading || !!batchUpdating"
                                    :status="'ready'"
                                    :grouping="'order_pulled'"
                                    :statuses="statuses"
                                    :orderStatues="order"
                                    :orderItem="true"
                                    :items="orderStatuses.hold.items"
                                    :lastMoveAttempt="lastMoveAttempt"
                                    :lastMoveAttemptSet="(e) => {lastMoveAttempt = e;}"
                                    :path="'orderStatuses.hold.items' "
                                    :seekAndRemove="(e) => { orderStatuses.hold.items = seekAndDestroy(orderStatuses.hold.items, e); }"
                                    :replace="(e) => {orderStatuses.hold.items= e}"
                                >
                            </batchTable>
                        </b-card>


                        <!-- Zero -->
                        <b-card class="" body-class="py-3" header-class="p-2">
                            <template v-slot:header>
                                    <span class="h6">
                                    <i class="fa-solid fa-magnet mr-1" style="color: #c40285;"></i>Zero
                                    </span>
                                     <b-card class="d-inline-block small mb-0 float-right"
                                        bg-variant="info"

                                        body-class="px-1 py-0">Load all onto scale and rescan barcode.
                                     </b-card>
                                <div class="batch-info mb-1">
                                    <span class="px-1">Weight: {{ getOrderStatusesTotals.zero.weight }}</span>
                                    <span class="px-1">Bags: {{ getOrderStatusesTotals.zero.bags }}</span>
                                    <span class="px-1">Items: {{ getOrderStatusesTotals.zero.items }}</span>
                                </div>
                            </template>
                            <batchTable
                                    :search="searchBatch"
                                    @updateOrderItems="updateOrderItems"
                                    @updateItemsOnMove="updateItemsOnMove"
                                    :seekItemsCallback="seekItemByGroup"
                                    :loading="!!singleOrderLoading || !!orderLoading || !!batchUpdating"
                                    :status="'ready'"
                                    :grouping="'order_zero'"
                                    :lastMoveAttempt="lastMoveAttempt"
                                    :lastMoveAttemptSet="(e) => {lastMoveAttempt = e;}"
                                    :statuses="statuses"
                                    :orderStatues="order"
                                    :orderItem="true"
                                    :items="orderStatuses.zero.items"
                                    :seekAndRemove="(e) => { orderStatuses.zero.items = seekAndDestroy(orderStatuses.zero.items, e); }"
                                    :replace="(e) => {orderStatuses.zero.items= e}"
                                    :path=" 'orderStatuses.zero.items' ">
                            </batchTable>
                        </b-card>


                        <!-- Melt  -->
                        <b-card class="" body-class="py-3" header-class="p-2">
                            <template v-slot:header>
                                <span class="h6"><i class="fa-solid fa-fire text-danger"></i> To Melt</span>
                                <div class="batch-info mb-1">
                                    <span class="px-1">Weight: {{ getOrderStatusesTotals.melt.weight }}</span>
                                    <span class="px-1">Bags: {{ getOrderStatusesTotals.melt.bags }}</span>
                                    <span class="px-1">Items: {{ getOrderStatusesTotals.melt.items }}</span>
                                </div>
                            </template>
                            <batchTable
                                    :search="searchBatch"
                                    @updateOrderItems="updateOrderItems"
                                    @updateItemsOnMove="updateItemsOnMove"
                                    :seekItemsCallback="seekItemByGroup"
                                    :loading="!!singleOrderLoading || !!orderLoading || !!batchUpdating"
                                    :status="'ready'"
                                    :grouping="'order_binned'"
                                    :statuses="statuses"
                                    :orderStatues="order"
                                    :lastMoveAttempt="lastMoveAttempt"
                                    :lastMoveAttemptSet="(e) => {lastMoveAttempt = e;}"
                                    :orderItem="true"
                                    :items="orderStatuses.melt.items"
                                    :seekAndRemove="(e) => { orderStatuses.melt.items = seekAndDestroy(orderStatuses.melt.items, e); }"
                                    :replace="(e) => {orderStatuses.melt.items= e}"
                                    :path=" 'orderStatuses.melt.items' ">
                            </batchTable>
                        </b-card>
                    </div>
                </template>


            </b-col>


            <!-- ***************
                    BATCHED Items
            *****************-->

            <b-col cols="12" xl="5">
                <b-row>
                    <b-col>
                        <div class="col-header mb-3 pb-3 border-bottom">
                            <span class="h4"><i v-if="!!batchUpdating" class="fa-regular fa-spin fa-spinner"></i><i v-else class="fa-solid fa-sign-in-alt"></i> Batched</span>
                            <ScaleWeight class="float-right" v-on:scale-stable="scaleStable = $event"
                                         v-on:scale-weight="scaleWeight = $event"
                                         ref="scale"></ScaleWeight>
                        </div>
                    </b-col>
                </b-row>

                <!-- Batched Melt Bags -->
                <b-row>
                    <b-col>
                        <b-card class="" body-class="py-3" header-class="p-2">
                            <template v-slot:header>
                                <h6><i class="fa-solid fa-suitcase text-muted"></i> Melt Security Bags</h6>
                                <div class="batch-info mb-1">
                                    <span class="px-1">Weight: {{securityBagWeightTotals.weight}} </span>
                                    <span class="px-1">Bags: {{ securityBagWeightTotals.count }} </span>
                                    <span class="px-1">Items: {{securityBagWeightTotals.items}} </span>
                                </div>
                            </template>
                            <b-table borderless
                                     small
                                     show-empty
                                     class="bags-table small mb-0"
                                     :tbody-tr-class="batchBagRowClass"
                                     :items="bags"
                                     :fields="['bag','melt','items',{key:'weight', class:'text-right'}]"
                            >
                                <template v-slot:cell(bag)="data">
                                    {{ data.item.barcode }}
                                </template>
                                <template v-slot:cell(melt)="data">
                                    {{ data.item.metal | titleCase  }} <span v-if="data.item.purity_type == 'kt'">{{ data.item.purity }}&nbsp;{{ data.item.purity_type }}</span><i v-if="data.item.is_melee" class="fa-xs ml-1 text-info fa-regular fa-gem "></i>
                                </template>
                                <template v-slot:cell(weight)="data" class="text-right">
                                    {{ (parseFloat(data.item.dwt) || 0.00).toFixed(2) }}  dwt
                                </template>
                                <template v-slot:cell(items)="data" class="text-right">
                                    {{ parseInt(data.item.total_items) || 0}}
                                </template>
                            </b-table>
                            <template v-slot:footer>
<span style="font-size: 11px;">Black-colored items are opened security bags, gray items are closed. To edit
a security bag, scan its barcode. Scanning a new security bag barcode will create a
new security bag in the list.</span>
                            </template>
                        </b-card>
                    </b-col>
                </b-row>


                <b-form-row>
                    <b-col>
                        <b-button
                                @click="loadPendingBags"
                                :disabled="batchUpdating != false || emptyBagArray == true || statuses.binned.items.length == 0"
                                class="text-white"
                                size="sm"
                                variant="success">
                            <i v-if="batchUpdating == 'loadingBatch'" class="fa-regular fa-spin fa-spinner"></i>
                            <i v-else class="fa-solid fa-arrow-square-up"></i>
                            Load Pending Items
                        </b-button>

                        <b-dropdown id="report-dropdown" variant="primary" size="sm" class="ml-2 float-right"
                                    :disabled="batchUpdating != false">
                            <template #button-content>
                                <i v-if="batchUpdating == 'batchReport'" class="fa-regular fa-spin fa-spinner"></i>
                                <i v-else class="fa-solid fa-file"></i>
                                Batch Report
                            </template>
                            <b-dropdown-text v-if="masterBatchIdsPresent.length < 1">No Recent Batches</b-dropdown-text>
                            <b-dropdown-item v-for="item in masterBatchIdsPresent" @click="batchReport(item.batch_id)">{{item.text}}</b-dropdown-item>
                            <!-- Add Batch Report Re-run option -->
                             <b-dropdown-divider></b-dropdown-divider>
                             <b-dropdown-item @click="reRunBatchReport"><i class="fa-solid fa-clock-rotate-left"></i>Re-run Batch Report</b-dropdown-item>
                        </b-dropdown>
                        
                        <b-button
                                @click="closeBatch"
                                :disabled="batchUpdating != false || emptyBagArray == true || securityBagWeightTotals.weight == 0 || statuses.binned.items.length > 0"
                                class="text-white float-right"
                                size="sm"
                                variant="warning">
                            <i v-if="batchUpdating == 'close'" class="fa-regular fa-spin fa-spinner"></i>
                            <i v-else class="fa-solid fa-check-square"></i>
                            Close Batch
                        </b-button>
                    </b-col>
                </b-form-row>

                <!-- Batched search -->
                <b-row>
                    <b-col>
                        <b-input-group class="my-3">
                            <template v-slot:prepend>
                                <b-input-group-text><i class="fa-solid fa-search"></i></b-input-group-text>
                            </template>
                            <b-form-input placeholder="Search batched..." v-model="searchBatch" debounce="500"></b-form-input>
                            <template v-slot:append>
                                <b-button @click="searchBatch = ''">Clear</b-button>
                            </template>
                        </b-input-group>
                    </b-col>
                </b-row>

                <b-row>
                    <b-col class="font-sm text-center mb-2">
                            <i class="fa-fw fa-solid fa-inbox fa-sm"></i>: <b-badge variant="secondary" pill>Move to Binned</b-badge>
                            <i class="ml-4 fa-fw fa-solid fa-tags text-success fa-sm"></i>: <b-badge variant="secondary" pill>Move to Held</b-badge>
                            <i class="ml-4 fa-fw fa-solid fa-magnet fa-sm" style="color: #c40285;"></i>: <b-badge variant="secondary" pill>Move to Zero-Value</b-badge>
                            <i class="ml-4 fa-fw fa-solid fa-question-circle text-danger fa-sm"></i>: <b-badge variant="secondary" pill>Move to Exception</b-badge>
                    </b-col>
                </b-row>


                <!-- Batched binned items table -->
                <b-row>
                    <b-col>

                        <b-card class="" body-class="py-3" header-class="p-2">
                            <template v-slot:header>
                                <h6><i class="fa-solid fa-inbox"></i> Binned Items (to be bagged for melt)</h6>
                                <div class="batch-info mb-1">
                                    <span class="px-1">Weight: {{ getBatchStatusesTotals.binned.weight }}</span>
                                    <span class="px-1">Bags: {{ getBatchStatusesTotals.binned.bags }}</span>
                                    <span class="px-1">Items: {{ getBatchStatusesTotals.binned.items }}</span>
                                </div>
                            </template>


                            <batchTableNoMenu
                                    :search="searchBatch"
                                    @updateOrderItems="updateOrderItems"
                                    @updateItemsOnMove="updateItemsOnMove"
                                    :seekItemsCallback="seekItemByGroup"
                                    :loading="!!singleOrderLoading || !!orderLoading || !!batchUpdating"
                                    :grouping="'binned'"
                                    :statuses="statuses"
                                    :orderStatues="order"
                                    :lastMoveAttempt="lastMoveAttempt"
                                    :lastMoveAttemptSet="(e) => {lastMoveAttempt = e;}"
                                    :orderItem="false"
                                    :status="'binned'"
                                    :seekAndRemove="(e) => { statuses.binned.items= seekAndDestroy(statuses.binned.items, e); }"
                                    :items="statuses.binned.items"
                                    :replace="(e) => {statuses.binned.items = e}"
                                    :path=" 'statuses.binned.items' ">
                            </batchTableNoMenu>
                        </b-card>
                    </b-col>
                </b-row>


                <!-- Batched recently held table -->
                <b-row>
                    <b-col>
                        <b-card class="" body-class="py-3" header-class="p-2">
                            <template v-slot:header>
                                <span class="h6"><i class="fa-solid fa-tags text-success mr-1"></i> Held Items</span>
                                <div class="batch-info ml-3">
                                    <span class="px-1">Weight: {{ getBatchStatusesTotals.pulled.weight }}</span>
                                    <span class="px-1">Bags: {{ getBatchStatusesTotals.pulled.bags }}</span>
                                    <span class="px-1">Items: {{ getBatchStatusesTotals.pulled.items }}</span>
                                </div>
                            </template>
                            <batchTableNoMenu
                                    :search="searchBatch"
                                    @updateOrderItems="updateOrderItems"
                                    @updateItemsOnMove="updateItemsOnMove"
                                    :seekItemsCallback="seekItemByGroup"
                                    :loading="!!singleOrderLoading || !!orderLoading || !!batchUpdating"
                                    :grouping="'pulled'"
                                    :statuses="statuses"
                                    :orderStatues="order"
                                    :lastMoveAttempt="lastMoveAttempt"
                                    :lastMoveAttemptSet="(e) => {lastMoveAttempt = e;}"
                                    :status="'pulled'"
                                    :orderItem="false"
                                    :seekAndRemove="(e) => { statuses.pulled.items= seekAndDestroy(statuses.pulled.items, e); }"
                                    :replace="(e) => {statuses.pulled.items = e}"
                                    :items="statuses.pulled.items"
                                    :path=" 'statuses.pulled.items' ">
                            </batchTableNoMenu>
                        </b-card>
                    </b-col>
                </b-row>


                <!-- Batched zero value  -->
                <b-row>
                    <b-col>
                        <b-card class="" body-class="py-3" header-class="p-2">
                            <template v-slot:header>
                                <span class="h6"><i class="fa-solid fa-magnet mr-1" style="color: #c40285;"></i> Zero-Value Items</span>
                                <div class="batch-info mb-1">
                                    <span class="px-1">Weight: {{ getBatchStatusesTotals.zerovalue.weight }}</span>
                                    <span class="px-1">Bags: {{ getBatchStatusesTotals.zerovalue.bags }}</span>
                                    <span class="px-1">Items: {{ getBatchStatusesTotals.zerovalue.items }}</span>
                                </div>
                            </template>
                            <batchTableNoMenu
                                    :search="searchBatch"
                                    @updateOrderItems="updateOrderItems"
                                    @updateItemsOnMove="updateItemsOnMove"
                                    :seekItemsCallback="seekItemByGroup"
                                    :loading="!!singleOrderLoading || !!orderLoading || !!batchUpdating"
                                    :grouping="'zero'"
                                    :statuses="statuses"
                                    :orderStatues="order"
                                    :lastMoveAttempt="lastMoveAttempt"
                                    :lastMoveAttemptSet="(e) => {lastMoveAttempt = e;}"
                                    :status="'zero-value'"
                                    :orderItem="false"
                                    :items="statuses.zerovalue.items"
                                    :seekAndRemove="(e) => { statuses.zerovalue.items= seekAndDestroy(statuses.zerovalue.items, e); }"
                                    :replace="(e) => {statuses.zerovalue.items = e}"
                                    :path=" 'statuses.zerovalue.items' ">
                            </batchTableNoMenu>
                        </b-card>
                    </b-col>
                </b-row>


                <!-- Batched exceptions table -->
                <b-row>
                    <b-col>
                        <h6 class="d-none"><i class="fa-solid fa-question-circle text-danger"></i> Exceptions</h6>
                        <b-card class="" body-class="py-3" header-class="p-2">
                            <template v-slot:header>
                                <span class="h6"><i class="fa-solid fa-question-circle text-danger"></i> Exceptions</span>
                                <div class="batch-info mb-1">
                                    <span class="px-1">Weight: {{ getBatchStatusesTotals.exception.weight }}</span>
                                    <span class="px-1">Bags: {{ getBatchStatusesTotals.exception.bags }}</span>
                                    <span class="px-1">Items: {{ getBatchStatusesTotals.exception.items }}</span>
                                </div>
                            </template>
                            <batchTableNoMenu
                                    :search="searchBatch"
                                    :seekItemsCallback="seekItemByGroup"
                                    :loading="!!singleOrderLoading || !!orderLoading || !!batchUpdating"
                                    :grouping="'exception'"
                                    :status="'exception'"
                                    :statuses="statuses"
                                    :orderStatues="order"
                                    :lastMoveAttempt="lastMoveAttempt"
                                    :lastMoveAttemptSet="(e) => {lastMoveAttempt = e;}"
                                    :orderItem="false"
                                    :items="statuses.exception.items"
                                    :seekAndRemove="(e) => { statuses.exception.items= seekAndDestroy(statuses.exception.items, e); }"
                                    :replace="(e) => {statuses.exception.items = e}"
                                    :path=" 'statuses.exception.items' ">
                            </batchTableNoMenu>
                        </b-card>
                    </b-col>
                </b-row>
            </b-col>
        </b-row>

        <b-modal :title="'Create New Security Bag - Options'" id="create-security-bag-modal-debug" :ok-title="'Create Security Bag'"
                 v-model="debugBagBarcodeValid"
                 @ok="debugActivateSecurityBagModal">
            <h5>Please enter bag barcode:</h5>
            <b-form-group
                    id="secure-bag-metal-group"
                    label="debug barcode"
                    label-for="secure-bag-metal"
            >
                <b-form-input v-model="debugBagBarcode" :options="secureBagModal.metal_types"
                               id="secure-bag-metal"
                ></b-form-input>
            </b-form-group>
        </b-modal>
        <validation-observer ref="observer" v-slot="{ passes, invalid }">
            <b-modal :title="secureBagModal.matchedBag ? 'Update Security Bag - Options' : 'Create New Security Bag - Options'" id="create-security-bag-modal" :ok-title="secureBagModal.matchedBag ? 'Update Security Bag': 'Create Security Bag'"
                     v-model="secureBagModal.show"
                     :ok-disabled="invalid"
                     @ok="createSecurityBag">
                <h5>Please enter bag details:</h5>

                <b-form>
                    <validation-provider
                            v-if="!secureBagModal.payload.is_melee"
                            name="metal"
                            :rules="{ required: true }"
                            immediate
                            v-slot="validationContext"
                    >
                        <b-form-group
                                id="secure-bag-metal-group"
                                label="metal"
                                label-for="secure-bag-metal"
                        >
                            <b-form-select v-model="secureBagModal.payload.metal" :options="secureBagModal.metal_types"
                                           id="secure-bag-metal"
                                           :disabled="secureBagModal.matchedBag != null"
                                           :state="getValidationState(validationContext)"
                            ></b-form-select>
                        </b-form-group>
                    </validation-provider>
                    <b-row>
                        <b-col cols="2">
                            <validation-provider
                                    name="is Melee?"
                                    immediate
                                    v-slot="validationContext">
                                <b-form-group
                                        id="secure-bag-melee-group"
                                        label="Is Melee?"
                                        label-for="secure-bag-melee">
                                    <b-form-checkbox
                                            class="nice-toggle-success ml-2 mt-3"
                                            id="secure-bag-melee"
                                            v-model="secureBagModal.payload.is_melee"
                                            name=""
                                            switch>
                                    </b-form-checkbox>
                                </b-form-group>
                            </validation-provider>
                        </b-col>
                        <b-col cols="10">
                            <validation-provider
                                    v-if="secureBagModal.payload.metal == 'gold' && !secureBagModal.payload.is_melee"
                                    name="purity"
                                    :rules="{ required: true }"
                                    immediate
                                    v-slot="validationContext">
                                <b-form-group
                                        id="secure-bag-purity-group"
                                        label="purity"
                                        label-for="input-shipping-method">
                                    <b-form-select v-model="secureBagModal.payload.purity" :options="secureBagModal.gold_purities"
                                                   id="secure-bag-purity"
                                                   :state="getValidationState(validationContext)"
                                    ></b-form-select>
                                </b-form-group>
                            </validation-provider>
                        </b-col>
                    </b-row>
                </b-form>
            </b-modal>
        </validation-observer>


        <!-- Express Checkout Modal -->
        <b-modal id="express-checkout" body-class="p-5" modal-class="express-checkout-modal"
                 size="xl" hide-footer hide-header :body-bg-variant="expressCheckoutColor" v-model="expressCheckoutActive">
            <div class="text-center mb-5" v-if="order">
                <i class="fa-solid fa-shopping-cart fa-5x mb-3"></i>
                <h2>Express Checkout - Order {{order.id}}</h2>
            </div>
            <b-table-simple dark class="text-center" v-if="order" :variant="expressCheckoutColor">
                <b-thead :variant="expressCheckoutColor">
                    <b-tr :variant="expressCheckoutColor">
                        <b-th>Bag Type</b-th>
                        <b-th>Items</b-th>
                        <b-th>Item dwt</b-th>
                        <b-th>Bag dwt</b-th>
                        <b-th>Total dwt</b-th>
                    </b-tr>
                </b-thead>
                <b-tbody :variant="expressCheckoutColor" class="express_checkout_table">
                    <b-tr ref="expressItems" v-for="(item,index) in quickBatch" :key="index" :variant="expressCheckoutColor">
                        <b-td><b>{{ item.metal | titleCase }}</b></b-td>
                        <b-td>{{item.child_items.length}}</b-td>
                        <b-td>{{quickSortDwtItem(item) | toFixed2 }} dwt</b-td>
                        <b-td>
                            <b-select @change="expressCheckoutBagSelection(item, index)" ref="expressBags" v-model="item.container.bag_type_id">
                                <b-form-select-option v-for="(bags,checkOutBagIndex) in bagTypes" :value="bags.id" :key="checkOutBagIndex">
                                    {{bags.bag_dwt | toFixed2}}&nbsp;{{bags.name}}
                                </b-form-select-option>
                            </b-select>
                        </b-td>
                        <b-td v-if="item.isLoading == true"><i class="fa-regular fa-spin fa-spinner"></i></b-td>
                        <b-td v-else>{{ item.weight }}</b-td>

                    </b-tr>
                    <b-tr :variant="expressCheckoutColor">
                        <b-td><b>{{ quickBatchTotals.totalBags }} melt bag(s)</b></b-td>
                        <b-td>{{quickBatchTotals.itemsCount }}</b-td>
                        <b-td>{{quickBatchTotals.itemDWT | toFixed2 }} dwt</b-td>
                        <b-td>{{quickBatchTotals.bagDWT | toFixed2 }} dwt</b-td>
                        <b-td>{{quickBatchTotals.totalDWT | toFixed2 }} dwt</b-td>
                    </b-tr>
                </b-tbody>
            </b-table-simple>
            <LoadingSpinner :busy="!order"/>
        </b-modal>

        <!-- Batch Re-run Modal -->
        <b-modal :title="'Re-run Batch Report'" id="batch-report-rerun-modal" body-class="p-5" modal-class=""
                 size="lg" hide-footer v-model="reRunBatchReportModal.show">
            <b-form-group
                label="Batch Date:"
                label-for="nested-batch-date"
                label-cols="2"
                label-align="right"
            >
                <b-form-select id="nested-batch-date" v-if="reRunBatchReportModal.batchRerun.batch_list.length" v-model="reRunBatchReportModal.batchRerun.batch_id" :options="reRunBatchReportModal.batchRerun.batch_list">
                    <template #first>
                        <b-form-select-option :value="null" disabled>Select a batch to rerun</b-form-select-option>
                    </template>
                </b-form-select>
                <template v-else>
                    <i class="fa-solid fa-spinner fa-spin fa-lg mr-2"></i> Loading batch list...
                </template>
            </b-form-group>

            <b-form-group
                label="(Or) Batch ID:"
                label-for="nested-batch-id"
                label-cols="2"
                label-align="right"
                content-cols="2"
            >
                <b-form-input id="nested-batch-id" number v-model="reRunBatchReportModal.batchRerun.batch_id"></b-form-input>
            </b-form-group>

            <b-card
                bg-variant="light"
                header="Spot Pricing Overrides"
                header-tag="label"
                sub-title="If a metal is left blank, the report will use the batch-date pricing for that metal."
                sub-title-tag="p">
                <b-row>
                    <b-col>
                        <b-form-group
                            label="Gold"
                            label-for="nested-batch-id"
                        >
                            <b-input-group prepend="$">
                                <b-form-input id="nested-batch-id" type="text"
                                lazy-formatter
                                :formatter="$inputSanitizer.toNumeric"
                                v-model="reRunBatchReportModal.batchRerun.spot_price_overrides.gold"></b-form-input>
                            </b-input-group>
                        </b-form-group>
                    </b-col>
                    <b-col>
                        <b-form-group
                            label="Silver"
                            label-for="nested-batch-id"
                        >
                            <b-input-group prepend="$">
                                <b-form-input id="nested-batch-id" type="text"
                                lazy-formatter
                                :formatter="$inputSanitizer.toNumeric"
                                v-model="reRunBatchReportModal.batchRerun.spot_price_overrides.silver"></b-form-input>
                            </b-input-group>
                        </b-form-group>
                    </b-col>
                    <b-col>
                        <b-form-group
                            label="Platinum"
                            label-for="nested-batch-id"
                        >
                            <b-input-group prepend="$">
                                <b-form-input id="nested-batch-id" type="text"
                                lazy-formatter
                                :formatter="$inputSanitizer.toNumeric"
                                v-model="reRunBatchReportModal.batchRerun.spot_price_overrides.platinum"></b-form-input>
                            </b-input-group>
                        </b-form-group>
                    </b-col>
                    <b-col>
                        <b-form-group
                            label="Palladium"
                            label-for="nested-batch-id"
                        >
                            <b-input-group prepend="$">
                                <b-form-input id="nested-batch-id" type="text"
                                lazy-formatter
                                :formatter="$inputSanitizer.toNumeric"
                                v-model="reRunBatchReportModal.batchRerun.spot_price_overrides.palladium"></b-form-input>
                            </b-input-group>
                        </b-form-group>
                    </b-col>
                </b-row>


            </b-card>

            <div class="text-right">
            <b-button :disabled="reRunBatchReportModal.loading" variant="primary" v-on:click="confirmBatchReportRerun">
                <i v-if="reRunBatchReportModal.loading" class="fa-regular fa-spin fa-spinner mr-2"></i>
                Run Report
            </b-button>
            <b-button class="ml-2" variant="secondary" @click="closeReRunBatchReport">Cancel</b-button>
            </div>
        </b-modal>
    </div>
</template>

<script>
    import _ from 'lodash';
    import orderTable from './components/orderTable';
    import batchTable from './components/batchTable';
    import batchTableNoMenu from './components/batchTableNoMenu';
    import ScaleWeight from '@/components/ScaleWeight';
    import LoadingSpinner from '@/components/LoadingSpinner';
    import WeightValidation from '@/components/WeightValidation';

    export default {
        name: 'batch-index',
        title: 'Batch',
        components: {
            orderTable,
            ScaleWeight,
            batchTable,
            batchTableNoMenu,
            LoadingSpinner,
            WeightValidation: WeightValidation,
        },

        data() {
            return {
                batch_id: null,
                order_verified: false,
                selected: null,
                orders: [],
                orderSelected: false,
                searchBatch: '',
                order: null,
                orderLoading: true,
                singleOrderLoading: false,
                batchUpdating: 'loadingAllBatch',
                emptyBagArray: true,
                bags: [],
                debugBagBarcode: null,
                expressCheckoutColor: 'dark',
                scaleStable: false,
                scaleWeight: null,
                orderQuickCheckStage: 0,
                expressCheckoutActive: false,
                orderQuickCheckError: false,
                oldBatches: [],
                lastMoveAttempt: null,
                secureBagModal: {
                    show: false,
                    payload: {
                        barcode: null,
                        purity: null,
                        is_melee: false,
                        metal: 'gold'
                    },
                    matchedBag: null,
                    metal_types: [
                        {value: 'gold', text:'Gold'},
                        {value: 'silver', text:'Silver'},
                        {value: 'palladium', text:'Palladium'},
                        {value: 'platinum', text:'Platinum'},
                        {value: 'gold-filled', text:'Gold Filled'},
                        {value: 'dental', text:'Dental'},
                    ],
                    gold_purities: [
                        {value: '10', text:'10 kt'},
                        {value: '14', text:'14 kt'},
                        {value: '18', text:'18 kt'},
                        {value: '24', text:'24 kt'},
                    ]

                },
                reRunBatchReportModal: {
                    show: false,
                    loading: false,
                    batchRerun: {
                        batch_id: null,
                        batch_list: [],
                        spot_price_overrides: {
                            gold: null,
                            silver: null,
                            platinum: null,
                            palladium: null,
                        }
                    }
                },
                statuses: {
                    pulled: {
                        items: []
                    },
                    zerovalue: {
                        items: []
                    },
                    exception: {
                        items: []
                    },
                    binned: {
                        items: []
                    }
                },
                orderStatuses: {
                    'melt': {'items':[]},
                    'zero': {'items':[]},
                    'hold': {'items':[]}
                },
                bagTypes: [],
            };
        },
        created() {
            this.$store.dispatch('LOAD_BAGTYPES', (bags) => {
                this.bagTypes = bags;
            });

            this.loadBatch();
        },

        mounted() {
            this.$barcodeScanner.init((rawBarcode) => {
                this.$barcodeScanner.parseBarcode(rawBarcode, (barcode, context) => {
                    if (this.batchUpdating) {
                        this.$bvModal.msgBoxOk('Batch is currently processing, please wait', {
                            title: 'Batch Processing',
                            size: 'md',
                            buttonSize: 'sm',
                            okVariant: 'danger',
                            headerClass: 'p-2 border-bottom-0 text-center d-block',
                            footerClass: 'p-2 border-top-0',
                        });
                    } else {
                        //this.$router.push({path: '/offer-generation/view/' + encodeURIComponent(barcode)});
                        console.log(encodeURIComponent(barcode), context);
                        switch (context) {
                            case 'O':
                                this.getOrder(encodeURIComponent(barcode));
                                break;
                            case 'B':
                                this.scanBagIn(encodeURIComponent(barcode));
                                break;
                            case 'I':
                                this.scanInventoryIn(encodeURIComponent(barcode));
                                break;
                            case 'SB':
                                this.activateSecurityBagModal(encodeURIComponent(barcode));
                                break;
                        }
                    }
                });
            });
            document.addEventListener("keydown", (event) => {
                if (event.key == "[") { //{
                    this.debugBagBarcode = "";
                }
            });
        },
        beforeDestroy() {
            this.$barcodeScanner.destroy();
        },
        computed: {
            debugBagBarcodeValid: {
                get() {
                    return this.debugBagBarcode !== null
                },
                set(val) {
                    if(val === false) {
                        this.debugBagBarcode = null;
                    }
                }
            },
            allOrderItems() {
                let items = [];
                _.forEach(this.orderStatuses, (data) => {
                    _.forEach(data.items, (e) => {
                        items.push(e);
                    });
                });
                return items;
            },
            masterBatchIdsPresent() {
                let batchIds = [];
                //batchIds.push({batch_id:this.batch_id, text: "Current Batch"});
                let options = {
                    year: 'numeric', month: 'numeric', day: 'numeric',
                    hour: 'numeric', minute: 'numeric',
                    timeZone: 'America/New_York'
                };
                _.forEach(this.oldBatches, (e, i) => {
                    //if(_.findIndex(batchIds, (z) => e.batch_id == z.batch_id) == -1) {
                        let date = new Date(e.closed_at);
                        batchIds.push({batch_id:e.id, text: (i === 0 ? 'Latest ' : '') + 'Batch - Closed: ' + new Intl.DateTimeFormat('en-US', options).format(date)});
                    //}
                });
                return batchIds;
            },
            securityBagWeightTotals() {
                let totals = {
                    items: 0,
                    count: 0,
                    weight: 0
                };
                _.forEach(this.bags, (e) => {
                    totals.count++;
                    totals.items += parseInt(e.total_items);
                    totals.weight += parseFloat(e.dwt) || 0;
                });
                return  totals;
            },
            quickBatch() {
                return _.filter(this.orderStatuses.melt.items, (item) => {
                    return !item.contains_melee;
                });
            },
            quickBatchTotals() {
                let totalBags = 0;
                let itemsCount = 0;
                let itemDWT = 0;
                let bagDWT = 0;
                _.forEach(this.quickBatch, item => {
                    totalBags += 1;
                    itemsCount += item.child_items.length;
                    itemDWT += _.sum(_.map(item.child_items, (e)=>{return e.dwt;}));
                    bagDWT += parseFloat(item.container.bagType.bag_dwt);
                });
                return {totalBags: _.round(totalBags,2), totalDWT: _.round(itemDWT+bagDWT,2), itemsCount: _.round(itemsCount,2),itemDWT: _.round(itemDWT,2) ,bagDWT: _.round(bagDWT,2)};
            },
            batch() {
                let batch = new Map();
                _.forEach(this.orders, (order) => {
                    let paid_at = this.getFormattedDate(order.paid_at ? new Date(order.paid_at) : new Date());
                    if(!batch.get(paid_at)) {
                        batch.set(paid_at, {'num_orders': 0 ,orders:[], 'date': null});
                    }
                    batch.get(paid_at).orders.push(order);
                    batch.get(paid_at).num_orders++;
                });
                let batchRet = [];
                batch.forEach((value, key) => {
                    value.date = key;
                    batchRet.push(value);
                });
                return batchRet.sort((a, b) => new Date(a.date) - new Date(b.date));
            },
            batchPurityBagCount() {
                let batchPurityBagCount = 0;
                _.forEach(this.orders, (order) => {
                    batchPurityBagCount = batchPurityBagCount + parseInt(order.purity_bag_count);
                });
                return batchPurityBagCount;
            },
            orderVerified() {
                return !this.order_verified ? 'muted' : '';
            },

//            // computed totals for items and weight for all batched status
            getBatchStatusesTotals () {
                let self = this;
                let batchStatuses = {
                    zerovalue: {}, binned: {},
                    exception: {}, pulled: {}
                };
                let keys = ['zerovalue', 'binned', 'exception', 'pulled'];
                keys.forEach(function (key) {
                    let weight = 0;
                    let bags = 0;
                    let items = 0;
                    let batchStatusPath = self.statuses[key].items;
                    batchStatusPath.forEach(function (object) {
                        if(object.container_type == 'bag') {
                            bags += 1;
                            items += object.child_items.length;
                        }
                        else {
                            bags += 1;
                            items += 1;
                        }
                        weight += parseFloat(object.dwt);
                    });
                    let batchStatusObj = {
                        weight: weight.toFixed(2),
                        items: items,
                        bags: bags,
                    };
                    batchStatuses[key] = batchStatusObj;
                });
                return batchStatuses;
            },


            // computed totals for items and weight for all order item statuses
            getOrderStatusesTotals () {
                let self = this;
                let orderStatuses = {
                    hold: {}, melt: {},
                    zero: {},
                };
                let keys = ['hold', 'melt', 'zero'];
                keys.forEach(function (key) {
                    let weight = 0;
                    let bags = 0;
                    let items = 0;
                    let orderStatusesPath = self.orderStatuses[key].items;
                    orderStatusesPath.forEach(function (object) {
                        if(object.container_type == 'bag') {
                            bags += 1;
                            items += object.child_items.length;
                        }
                        else {
                            bags += 1;
                            items += 1;
                        }
                        weight += parseFloat(object.dwt);
                    });
                    let orderStatusObj = {
                        weight: weight.toFixed(2),
                        items: items,
                        bags: bags,
                    };
                    orderStatuses[key] = orderStatusObj;
                });
                return orderStatuses;
            }
        },
        methods: {
            //fixes major rendering issues with batchInventory
            refreshRender() {
                _.forEach(this.$root.$children, (e) => {
                    e.$forceUpdate();
                });
            },
            refreshBatch() {
                this.order = null;
            },
            refreshBatchOrderList() {
                this.orderLoading = true;
                this.orders = [];
                this.$forceUpdate();
                this.loadBatch();
            },
            debugActivateSecurityBagModal() {
                this.activateSecurityBagModal(this.debugBagBarcode);
            },
            activateSecurityBagModal(barcode) {
                this.secureBagModal.show = true;
                let matchedBag = null;
                _.forEach(this.bags, (e) => {
                    if(e.barcode == barcode && e.total_items == 0) {
                        matchedBag = e;
                    }
                });
                this.secureBagModal.matchedBag = matchedBag;
                this.secureBagModal.payload = {
                    'is_melee': matchedBag ? (matchedBag.is_melee ? true : false) : false,
                    'barcode': barcode, //have this null for real reset
                    'purity': matchedBag ? (matchedBag.purity ? parseInt(matchedBag.purity).toString() : null) : null,
                    'metal': matchedBag ? matchedBag.metal : 'gold',
                };
                this.secureBagModal.show = true;
            },
            scanBagIn(id) {
                if(!this.scaleStable) {
                    this.$bvModal.msgBoxOk('Scale Weight is not stable.', {
                        title: 'Invalid Weight',
                        size: 'md',
                        buttonSize: 'sm',
                        okVariant: 'danger',
                        headerClass: 'p-2 border-bottom-0 text-center d-block',
                        footerClass: 'p-2 border-top-0',
                    });
                    return;
                }
                let i = 0;
                let result = null;
                //****************** CHECK MELT ***************
                for(; i < this.orderStatuses.melt.items.length; i++) {
                    let item = this.orderStatuses.melt.items[i];
                    if(item.component_id == id) {
                        result = item;
                        break;
                    }
                }
                if(result != null) {
                    if(Math.abs( parseFloat(result.dwt) - parseFloat(this.scaleWeight)) <= .4) {
                        this.lastMoveAttempt = "scan - bag";
                        let itemsToAdd = _.remove(this.orderStatuses.melt.items, function (e) {
                            return e.component_id == id;
                        });
                        this.statuses.binned.items = _.concat(itemsToAdd, this.statuses.binned.items);
                        //the darn thing wont rerender unless I super force it
                        this.orderStatuses.melt.items = _.remove(this.orderStatuses.melt.items, (e) => {return e.component_id != id;});
                        this.refreshRender();
                    } else {
                        this.$bvModal.msgBoxOk('Weight is invalid. expected (' +result.dwt + '), but Instead got (' + this.scaleWeight + ')', {
                            title: 'Invalid Weight',
                            size: 'md',
                            buttonSize: 'sm',
                            okVariant: 'danger',
                            headerClass: 'p-2 border-bottom-0 text-center d-block',
                            footerClass: 'p-2 border-top-0',
                        });
                    }
                    return;
                }
                //****************** CHECK Hold ***************
                for(i = 0; i < this.orderStatuses.hold.items.length; i++) {
                    let item = this.orderStatuses.hold.items[i];
                    if(item.component_id == id) {
                        result = item;
                        break;
                    }
                }
                if(result != null) {
                    if(Math.abs( parseFloat(result.dwt) - parseFloat(this.scaleWeight)) <= .4) {
                        this.lastMoveAttempt = "scan - bag";
                        let itemsToAdd = _.remove(this.orderStatuses.hold.items, function (e) {
                            return e.component_id == id;
                        });
                        this.statuses.pulled.items = _.concat(itemsToAdd,this.statuses.pulled.items);
                        //the darn thing wont rerender unless I super force it
                        this.orderStatuses.hold.items = _.remove(this.orderStatuses.hold.items, (e) => {return e.component_id != id;});
                        this.refreshRender();
                    } else {
                        this.$bvModal.msgBoxOk('Weight is invalid. expected (' +result.dwt + '), but Instead got (' + this.scaleWeight + ')', {
                            title: 'Invalid Weight',
                            size: 'md',
                            buttonSize: 'sm',
                            okVariant: 'danger',
                            headerClass: 'p-2 border-bottom-0 text-center d-block',
                            footerClass: 'p-2 border-top-0',
                        });
                    }
                    return;
                }
                //****************** CHECK zero value ***************
                for(i = 0; i < this.orderStatuses.zero.items.length; i++) {
                    let item = this.orderStatuses.zero.items[i];
                    if(item.component_id == id) {
                        result = item;
                        break;
                    }
                }
                if(result != null) {
                    if(Math.abs( parseFloat(result.dwt) - parseFloat(this.scaleWeight)) <= .4) {
                        this.lastMoveAttempt = "scan - bag";
                        let itemsToAdd = _.remove(this.orderStatuses.zero.items, function (e) {
                            return e.component_id == id;
                        });
                        this.statuses.zerovalue.items = _.concat(itemsToAdd, this.statuses.zerovalue.items);
                        //the darn thing wont rerender unless I super force it
                        this.orderStatuses.zero.items = _.remove(this.orderStatuses.zero.items, (e) => {return e.component_id != id;});

                        this.refreshRender();
                    } else {
                        this.$bvModal.msgBoxOk('Weight is invalid. expected (' +result.dwt + '), but Instead got (' + this.scaleWeight + ')', {
                            title: 'Invalid Weight',
                            size: 'md',
                            buttonSize: 'sm',
                            okVariant: 'danger',
                            headerClass: 'p-2 border-bottom-0 text-center d-block',
                            footerClass: 'p-2 border-top-0',
                        });
                    }
                    return;
                }
                this.$bvModal.msgBoxOk('Bag was not found', {
                    title: 'Not Found',
                    size: 'md',
                    buttonSize: 'sm',
                    okVariant: 'danger',
                    headerClass: 'p-2 border-bottom-0 text-center d-block',
                    footerClass: 'p-2 border-top-0',
                });
            },
            batchBagRowClass(item,type) {
                if (!item || type !== 'row') return;
                if (item.is_old) return 'text-muted';
            },
            quickSortDwtItem(item) {
                return _.sum(_.map(item.child_items, (e) => {return e.dwt;}));
            },
            scanInventoryIn(id) {
                if(!this.scaleStable) {
                    this.$bvModal.msgBoxOk('Scale Weight is not stable.', {
                        title: 'Invalid Weight',
                        size: 'md',
                        buttonSize: 'sm',
                        okVariant: 'danger',
                        headerClass: 'p-2 border-bottom-0 text-center d-block',
                        footerClass: 'p-2 border-top-0',
                    });
                    return;
                }
                let result = null;
                for(let j = 0; j < this.orderStatuses.melt.items.length; j++) {
                    let bag = this.orderStatuses.melt.items[j];
                    for(let i = 0; i < bag.child_items.length; i++) {
                        let item =  bag.child_items[i];
                        if(item.component_id == id) {
                            result = item;
                            break;
                        }
                    }
                    if(result != null) {
                        if(Math.abs(parseFloat(result.dwt) - parseFloat(this.scaleWeight)) <= .4) {
                            this.lastMoveAttempt = "scan - inventory";
                            let itemsToAdd = _.remove(this.orderStatuses.melt.items[j].child_items, function (e) {
                                return e.component_id == id;
                            });
                            this.statuses.binned.items = _.concat(itemsToAdd, this.statuses.binned.items);
                            //the darn thing wont rerender unless I super force it
                            this.orderStatuses.melt.items[j].child_items = _.remove(this.orderStatuses.melt.items[j].child_items, (e) => {return e.component_id != id;});

                            this.refreshRender();
                        } else {
                            this.$bvModal.msgBoxOk('Weight is invalid. expected (' +result.dwt + '), but Instead got (' + this.scaleWeight + ')', {
                                title: 'Invalid Weight',
                                size: 'md',
                                buttonSize: 'sm',
                                okVariant: 'danger',
                                headerClass: 'p-2 border-bottom-0 text-center d-block',
                                footerClass: 'p-2 border-top-0',
                            });
                        }
                        return;
                    }
                }
                for(let j = 0; j < this.orderStatuses.hold.items.length; j++) {
                    let bag = this.orderStatuses.hold.items[j];
                    //this is different since hold items do not have bags
                    if(bag.component_id == id) {
                        result = bag;
                    }
                    if(result != null) {
                        //hold items should be based off bag weight, not item weight.
                        if(Math.abs(parseFloat(bag.dwt) - parseFloat(this.scaleWeight)) <= .4) {
                            this.lastMoveAttempt = "scan - inventory";
                            let itemsToAdd = _.remove(this.orderStatuses.hold.items, function (e) {
                                return e.component_id == id;
                            });
                            this.statuses.pulled.items = _.concat(itemsToAdd, this.statuses.pulled.items);
                            //the darn thing wont rerender unless I super force it
                            this.orderStatuses.hold.items = _.remove(this.orderStatuses.hold.items, (e) => {return e.component_id != id;});
                            this.refreshRender();
                        } else {
                            this.$bvModal.msgBoxOk('Weight is invalid. expected (' +bag.dwt + '), but Instead got (' + this.scaleWeight + ')', {
                                title: 'Invalid Weight',
                                size: 'md',
                                buttonSize: 'sm',
                                okVariant: 'danger',
                                headerClass: 'p-2 border-bottom-0 text-center d-block',
                                footerClass: 'p-2 border-top-0',
                            });
                        }
                        return;
                    }
                }
                for(let j = 0; j < this.orderStatuses.zero.items.length; j++) {
                    let bag = this.orderStatuses.zero.items[j];
                    for(let i = 0; i < bag.child_items.length; i++) {
                        let item =  bag.child_items[i];
                        if(item.component_id == id) {
                            result = item;
                            break;
                        }
                    }
                    if(result != null) {
                        if(Math.abs(parseFloat(result.dwt) - parseFloat(this.scaleWeight)) <= .4) {
                            let itemsToAdd = _.remove(this.orderStatuses.zero.items[j].child_items, function (e) {
                                this.lastMoveAttempt = "scan - inventory";
                                return e.component_id == id;
                            });
                            this.statuses.zerovalue.items = _.concat(itemsToAdd, this.statuses.zerovalue.items);
                            //the darn thing wont rerender unless I super force it
                            this.orderStatuses.zero.items[j].child_items = _.remove(this.orderStatuses.zero.items[j].child_items, (e) => {return e.component_id != id;});
                            this.refreshRender();
                        } else {
                            this.$bvModal.msgBoxOk('Weight is invalid. expected (' +result.dwt + '), but Instead got (' + this.scaleWeight + ')', {
                                title: 'Invalid Weight',
                                size: 'md',
                                buttonSize: 'sm',
                                okVariant: 'danger',
                                headerClass: 'p-2 border-bottom-0 text-center d-block',
                                footerClass: 'p-2 border-top-0',
                            });
                        }
                        return;
                    }
                }
                this.$bvModal.msgBoxOk('Item was not found', {
                    title: 'Not Found',
                    size: 'md',
                    buttonSize: 'sm',
                    okVariant: 'danger',
                    headerClass: 'p-2 border-bottom-0 text-center d-block',
                    footerClass: 'p-2 border-top-0',
                });
            },
            weightValidation() {
                if (this.scaleStable && this.scaleWeight > 0 && this.expressCheckoutActive && this.order != null && this.quickBatch.length != 0) {
                    if(this.$refs.WeightValidation.validateBatch(this.scaleWeight, this.quickBatch)) {
                        this.expressCheckoutColor = 'success';
                        setTimeout(()=> {
                            this.$nextTick(() => {
                                if (this.orderStatuses.zero.items.length > 0 && this.quickBatch.length > 0) {
                                    this.lastMoveAttempt = "QuickScan~"; //marking to take an additional attempt to remove
                                } else if (this.orderStatuses.zero.items.length > 0 || this.quickBatch.length > 0) {
                                    this.lastMoveAttempt = "QuickScan";
                                }
                                this.statuses.zerovalue.items = _.concat( this.orderStatuses.zero.items, this.statuses.zerovalue.items);
                                this.statuses.binned.items = _.concat(this.quickBatch, this.statuses.binned.items);

                                this.orderStatuses.zero.items = [];
                                //forces rerender doing it this way, its backwards (returns removed elements and than set its as the value)
                                this.orderStatuses.melt.items = _.remove(this.orderStatuses.melt.items, (item) => {
                                    return -1 == _.findIndex(this.statuses.binned.items, (a) => {
                                        return a.id == item.id;
                                    });
                                });
                                this.$bvModal.hide('express-checkout');
                            });
                        }, 1000);
                    } else {
                        this.expressCheckoutColor = 'danger';
                    }
                } else if (this.expressCheckoutActive && this.order != null && this.quickBatch.length == 0) {
                    this.$bvModal.hide('express-checkout');
                }
            },
            getValidationState({dirty, validated, valid = null}) {
                return dirty || validated ? valid : null;
            },
            seekAndDestroy(topArray, item) {
                if(topArray) {
                    for (let i = 0; i < topArray.length; i++) {
                        topArray[i].child_items = this.seekAndDestroy(topArray[i].child_items, item);
                        if (topArray[i].id == item.id) {
                            topArray.splice(i, 1);
                        }
                    }
                }
                return topArray;
            },
            batchReport(id) {
                ///batch/{batch}/batchReport
                this.batchUpdating = 'batchReport';


                this.$http.get(this.$http.defaults.baseURL+'/batch/'+id+'/batchReport')
                .then(() => {
                    this.$bvModal.msgBoxOk('The file will take 3-5 minutes to generate, and will be sent via email when complete.', {
                        title: 'Batch report is generating.',
                        size: 'sm',
                        buttonSize: 'sm',
                        okVariant: 'success',
                        headerClass: 'p-2 border-bottom-0',
                        footerClass: 'p-2 border-top-0',
                        centered: true
                        });
                }).finally(() => {
                    this.batchUpdating = false;
                });
            },
            createSecurityBag() {
                ///batch/{batch}/addSecurityBag
                this.batchUpdating = 'creating_bag';
                //we also need a contains melee variant.!!
                //todo make this a choice
                this.secureBagModal.payload.type = 'small';
                if(this.secureBagModal.matchedBag) {

                    this.$http.post('/batch/' + this.secureBagModal.matchedBag.id + '/UpdateSecurityBag', this.secureBagModal.payload).then((response) => {
                        let result = response.data.data;
                        result.total_items = 0;
                        for(let i = 0; i < this.bags.length; i++) {
                            if (this.bags[i].id == this.secureBagModal.matchedBag.id) {
                                this.bags.splice(i, 1, result);
                                break;
                            }
                        }
                    }).finally((e) => {
                        this.batchUpdating = false;
                    });
                } else {
                    this.$http.post('/batch/' + this.batch_id + '/addSecurityBag', this.secureBagModal.payload).then((response) => {
                        let result = response.data.data;
                        result.total_items = 0;
                        this.bags.push(result);
                    }).finally((e) => {
                        this.batchUpdating = false;
                    });
                }
            },
            seekItemByGroup(listString){
                listString = listString.split('?');
                switch(listString[0]) {
                    case 'binned':
                        return this.seekItem(listString[1], this.statuses.binned.items, true);
                    case 'zero':
                        return this.seekItem(listString[1], this.statuses.zerovalue.items, true);
                    case 'pulled':
                        return this.seekItem(listString[1], this.statuses.pulled.items, true);
                    case 'exception':
                        return this.seekItem(listString[1], this.statuses.exception.items, true);
                    case 'order_binned':
                        return this.seekItem(listString[1], this.orderStatuses.melt.items, false);
                    case 'order_zero':
                        return this.seekItem(listString[1], this.orderStatuses.zero.items, false);
                    case 'order_pulled':
                        return this.seekItem(listString[1], this.orderStatuses.hold.items, false);
                    default:
                        console.log('ERROR');
                }
            },
            seekItem(listStrings, localStatuses, canMoveTo) {
                if(listStrings) {
                    let listString = listStrings.split('|');
                    if (listString[0].includes('parent_item')) {
                        for (let i = 0; i < localStatuses.length; i++) {
                            if (listString[1] == localStatuses[i].id) {
                                let confirmed = localStatuses[i];
                                if (listString[2]) {
                                    for (let j = 0; j < confirmed.child_items.length; j++) {
                                        if (confirmed.child_items[j].id == listString[2]) {
                                            return confirmed.child_items[j];
                                        }
                                    }
                                }
                                return confirmed;
                            }
                        }
                    }
                }
                return {container_type: 'list', data:listStrings, canMoveTo: canMoveTo}; //super list
            },
            getFormattedDate(date) {
                // console.log(date);
                var year = date.getFullYear();

                var month = (1 + date.getMonth()).toString();
                month = month.length > 1 ? month : '0' + month;

                var day = date.getDate().toString();
                day = day.length > 1 ? day : '0' + day;

                return month + '/' + day + '/' + year;
            },
            updateItemsOnMove(newList, newLocation, bag, path) {
//                console.log('new list: ', newList);
//                console.log('newLocation', newLocation);
//                console.log('bag', bag);
//                console.log('path', path);
                if(path[0] == 'statuses') {
                    //this.statuses = newList;
                } else {
                   // this.orderStatuses = newList;
                }
            },


            expressCheckoutBagSelection(item, index) {
                this.order.batchedItems[index].isLoading = true;
                this.$forceUpdate();
                this.$http.put('/bags/' + item.container.id, item.container).then((response) => {
                    this.order.batchedItems[index].isLoading = false;
                    this.order.batchedItems[index].container.bagType = response.data.data.bagType;
                    this.order.batchedItems[index].weight =  (this.quickSortDwtItem(this.order.batchedItems[index]) + parseFloat(response.data.data.bagType.bag_dwt)).toFixed(2) + ' dwt';
                    this.weightValidation();
                    this.$forceUpdate();
                });
            },

            // updating data from 'dragged' elements inside the batchTable component
            updateOrderItems(obj, path, orderItem) {
                let pathStr = path.split('.');
                if(orderItem) {
                //    this[pathStr[0]][pathStr[1]][pathStr[2]][pathStr[3]] = obj;
                } else {
               //     this[pathStr[0]][pathStr[1]][pathStr[2]] = obj;
                }
            },

            // for toggling open Upack dates
            toggleUnpackBatchDates(date) {
                let batchDate = document.getElementById(date);
                batchDate.classList.toggle('is-closed');
            },
            closeBatch() {
                this.$bvModal.msgBoxConfirm('Are you sure you want to close batch?', {
                    title: 'Close Batch?',
                    size: 'md',
                    okTitle: 'Yes',
                    buttonSize: 'sm',
                    okVariant: 'danger',
                    cancelVariant: 'secondary',
                    headerClass: 'p-2 border-bottom-0 text-center d-block',
                    footerClass: 'p-2 border-top-0',
                }).then((value)=>{
                    if(value){
                        this.batchUpdating = 'close';
                        this.order = null;
                        this.$http.post('/batch/'+this.batch_id+'/close').then((payload) => {
                            this.$parent.$bvModal.msgBoxOk("Batch has been closed!", {
                                id: 'alert_id',
                                title: "Success",
                                size: 'md',
                                buttonSize: 'sm',
                                okVariant: 'success',
                                headerClass: 'p-2 border-bottom-0 text-center d-block',
                                footerClass: 'p-2 border-top-0',
                            });
                            //reload all of batch
                            this.loadBatch();
                        }).catch((e)=>{
                            this.batchUpdating = false;
                        });
                    }
                });
            },
            loadPendingBags() {
                this.batchUpdating = 'loadingBatch';
                this.order = null;
                this.$http.post('/batch/'+this.batch_id+'/loadPendingItems').then((payload)=>{
                    this.processLooseInventory(payload);
                    this.processSecurityBagsPayload(payload);
                    //this.batchUpdating = false;
                    //this.$router.go(0);
                }).finally((e) => {
                    this.batchUpdating = false;
                });
            },


            /*
            *
            *
            * */

            processOrders(response) {
                this.orders = response.data.orders.data;
                this.$nextTick(() => {
                    this.orderLoading = false;
                });
            },
            processBatchPayload(batchResponse) {
                let batch = batchResponse.data.batch;
                this.batch_id = batch.id;
            },
            processSecurityBagsPayload(bagsResponse) {
                this.bags = bagsResponse.data.securityBags;
            },
            processLooseInventory(looseInventoryResponse) {
                this.statuses.pulled.items = [];
                this.statuses.binned.items = [];
                this.statuses.exception.items = [];
                this.statuses.zerovalue.items = [];
                _.forEach(looseInventoryResponse.data.batchInventory, (item) => {
                    console.log(this.batchUpdating);
                    switch(item.status) {
                        case 'pulled':
                            this.statuses.pulled.items.push(item);
                            break;
                        case 'binned':
                            this.statuses.binned.items.push(item);
                            break;
                        case 'exception':
                            this.statuses.exception.items.push(item);
                            break;
                        case 'zero-value':
                            this.statuses.zerovalue.items.push(item);
                            break;
                    }
                });
                this.$forceUpdate();
            },
            processUnpackResponse(unpackResponse) {
                this.orders = unpackResponse.data.orders.data;
            },
            processOldBatches(oldBatchResponse) {
                this.oldBatches = oldBatchResponse.data.oldBatches;
            },
            loadBatch() {
                this.isBusy = true;
                this.$http.get('/batch').then((batchResponse) => {
                    this.processBatchPayload(batchResponse);
                    this.$http.all([
                        this.$http.get('/batch/' + this.batch_id + '/old'),
                        this.$http.get('/batch/' + this.batch_id + '/bags'),
                        this.$http.get('/batch/' + this.batch_id + '/looseInventory'),
                        this.$http.get('/batch/' + this.batch_id + '/unPack')
                    ]).then(this.$http.spread((oldBatchResponse, bagsResponse, looseInventoryResponse, unpackResponse) => {
                        //do batched items
                        this.processOldBatches(oldBatchResponse);
                        this.processSecurityBagsPayload(bagsResponse);
                        this.processLooseInventory(looseInventoryResponse);
                        this.processUnpackResponse(unpackResponse);
                        this.$nextTick(() => {
                            this.orderLoading = false;
                            this.batchUpdating = false;
                        });
                    }));
                });
                /*
                this.$http.get('/batch').then(response => {
                    this.processBatch(response);
                    this.processOrders(response);
                    this.oldBatches = response.data.oldBatches;
                });*/
                //let data = '{"2020-04-20":{"num_orders":"1","orders":{"507434":{"hold_date":"2020-04-20","order_id":"507434","last_name":"Kaplan","num_items":"23"}}},"2020-04-16":{"num_orders":"2","orders":{"506078":{"hold_date":"2020-04-16","order_id":"506078","last_name":"Akers","num_items":"32"},"509608":{"hold_date":"2020-04-12","order_id":"509608","last_name":"Thomas","num_items":"2"}}},"2020-04-12":{"num_orders":1,"orders":{"509608":{"hold_date":"2020-04-12","order_id":"509608","last_name":"Thomas","num_items":"2"}}}}';
                //this.batch = JSON.parse(data);

            },
            // get Batched items (fa-regular right column)
            getBatchState() {
            },

            // get items for each order selected  (center column)
            getOrder(order_id) {
                if (this.order && this.order.id == order_id) {
                    if (this.orderStatuses.zero.items.length > 0) {
                        this.lastMoveAttempt = "zero value - confirm move";
                    }
                    this.statuses.zerovalue.items = _.concat(this.orderStatuses.zero.items, this.statuses.zerovalue.items);
                    this.orderStatuses.zero.items = [];
                    this.$forceUpdate();
                } else {
                    this.order_verified = false;

                    //this.order = JSON.parse(data);
                    this.order = null;
                    this.expressCheckoutColor = 'dark';
                    this.$bvModal.show('express-checkout');
                    this.singleOrderLoading = true;
                    this.$http.get('/batch/' + this.batch_id + '/' + order_id).then((response) => {
                        this.orderStatuses = {
                            'melt': {'items': []},
                            'zero': {'items': []},
                            'hold': {'items': []}
                        };
                        let batched = response.data.data.batchedItems;
                        _.forEach(batched, (e) => {
                            e.child_items = _.remove(e.child_items, (a) => {
                                return a.status == 'ready';
                            });
                            _.forEach(e.child_items, (z) => {
                                z.child_items = _.remove(z.child_items, (a) => {
                                    return a.status == 'ready';
                                });
                            });
                        });

                        this.$nextTick(() => {
                            this.orderQuickCheckStage = 1;
                            _.forEach(batched, (bag) => {
                                //if (!this.bagInBatch(bag)) {
                                //on hold
                                if (bag.container.bag_contents_status == 'hold' || bag.container_type == 'inventory') {
                                    this.orderStatuses.hold.items.push(bag);
                                }
                                //zero value
                                else if (_.filter(bag.child_items, (e) => {
                                    return (e.container.appraisal || {total: 0}).total != 0;
                                }).length == 0) {
                                    this.orderStatuses.zero.items.push(bag);
                                }
                                //default melt
                                else {
                                    this.orderStatuses.melt.items.push(bag);
                                }
                                //}
                            });
                            this.$forceUpdate();
                            this.order = response.data.data;
                            this.$nextTick(() => {
                                this.singleOrderLoading = false;
                                this.$nextTick(() => {
                                    this.weightValidation();
                                });
                            });
                        });
                    }).catch((e) => {
                        this.$bvModal.hide('express-checkout');
                    });
                }
                // show express checkout modal
            },
            reRunBatchReport() {
                this.reRunBatchReportModal.show = true;
                this.getBatchList();
            },
            closeReRunBatchReport() {
                this.reRunBatchReportModal.show = false;
                this.reRunBatchReportModal.batchRerun.spot_price_overrides = {
                    gold: null,
                    silver: null,
                    platinum: null,
                    palladium: null,
                };
                this.reRunBatchReportModal.batchRerun.batch_id = null;
            },
            getBatchList() {
                if (this.reRunBatchReportModal.batchRerun.batch_list.length) return; // Don't re-query if we already have batches

                let optionsNoTime = {year: 'numeric', month: 'numeric', day: 'numeric'};
                this.$http.get('/batch/old?backdate=60').then((data) => {
                    if (data && data.data.oldBatches) {
                        _.forEach(data.data.oldBatches, (e, i) => {
                            let date = new Date(e.closed_at);
                            this.reRunBatchReportModal.batchRerun.batch_list.push({value: e.id, text: (i === 0 ? 'Latest ' : '') + 'Batch ' + e.id + ' - ' + new Intl.DateTimeFormat('en-US', optionsNoTime).format(date)});
                        });
                    }
                });
            },
            confirmBatchReportRerun() {
                this.batchUpdating = 'batchReport';
                this.reRunBatchReportModal.loading = true;
                this.$http.get('/batch/' + this.reRunBatchReportModal.batchRerun.batch_id + '/batchReport', {
                    params: {
                        gold: this.reRunBatchReportModal.batchRerun.spot_price_overrides.gold,
                        silver: this.reRunBatchReportModal.batchRerun.spot_price_overrides.silver,
                        platinum: this.reRunBatchReportModal.batchRerun.spot_price_overrides.platinum,
                        palladium: this.reRunBatchReportModal.batchRerun.spot_price_overrides.palladium,
                    }
                }).then(() => {
                    this.$bvModal.msgBoxOk('The file will take 3-5 minutes to generate, and will be sent via email when complete.', {
                        title: 'Batch report is generating.',
                        size: 'sm',
                        buttonSize: 'sm',
                        okVariant: 'success',
                        headerClass: 'p-2 border-bottom-0',
                        footerClass: 'p-2 border-top-0',
                        centered: true
                    });
                })
                .finally(() => {
                    this.reRunBatchReportModal.show = false;
                    this.batchUpdating = false;
                    this.reRunBatchReportModal.batchRerun = {
                        batch_id: null,
                        batch_list: [],
                        spot_price_overrides: {
                            gold: null,
                            silver: null,
                            platinum: null,
                            palladium: null,
                        }
                    };
                    this.reRunBatchReportModal.loading = false;
                });
            }


        },
        watch: {
            bags: {
                deep: true,
                handler(data) {
                    this.emptyBagArray = !(data && data.length > 0 && _.find(data, i => {
                        return i.is_old === 0 || i.is_old == null;
                    }));
                }
            },
            ScaleWeight: function () {

            },
            scaleStable: function() {
                this.weightValidation();
            },
            allOrderItems: function(data) {
                  if(data.length == 0 && this.order) {
                      this.orders = _.remove(this.orders, (order) => {return order.id != this.order.id;});
                      this.order = null;
                  }
            },
        }

    };
</script>

<style scoped>
    .bags-table {
        font-size: 10px;
    }

    .small-font {
        font-size: 12px;
    }

    .table-hover tbody tr:hover {
        cursor: pointer;
    }

    .muted {
        opacity: .3;
        cursor: no-drop;
    }

    .batch-info {
        font-size: 70%;
    }

    .batch-scroll-lg {
        min-height: 250px;
        overflow: scroll;
    }

    .unpack-batch-date {
        overflow: hidden;
        cursor: pointer;

    }

    .unpack-batch-orders {
        transition: 3.5s ease all;
    }

    .unpack-batch-orders.is-closed {
        max-height: 0;
    }

    .express-checkout-modal {
        background-color: rgba(0, 0, 0, 0.5) !important;
    }

    #express-checkout table {
        font-size: 20px;
    }

    .express-checkout-modal .modal-lg {
        max-width: 1000px;
    }



    .slide-fade-enter-active {
        transition: all .3s ease;
    }
    .slide-fade-leave-active {
        transition: all .3s cubic-bezier(1.0, 0.5, 0.8, 1.0);
    }
    .slide-fade-enter, .slide-fade-leave-to {
        transform: translateX(10px);
        opacity: 0;
    }
</style>
<style>
    .express_checkout_table tr:last-child{
        box-shadow: 0px -2px 0px 0px #FFF
    }
</style>
